<template>
  <div>
    <div class="mb-4">
      <h4 class="font-weight-bold mb-2">
        <span class="text-muted font-weight-light">Administration</span> <span class="material-icons md-14 arrow-east">east</span>
        Tools <span class="material-icons md-14 arrow-east">east</span>
        Queries <span class="material-icons md-14 arrow-east">east</span>
        Brooks Running - Place Order Errors
      </h4>
    </div>

    <div class="d-flex mt-5" style="gap: 0.5rem;">
      <b-input type="date" v-model="dateFrom" name="dateFrom" title="Start date" style="width: 10rem;" />
      <b-input type="date" v-model="dateTo" name="dateTo" title="End date" style="width: 10rem;" />
      <b-button variant="primary" style="width: 10rem;" @click="getErrors">Run query</b-button>
    </div>

    <!-- Actions -->
    <div class="card card-body p-0 mt-3" v-if="results">
      <b-button variant="primary" @click="exportResults">Export (xlsx)</b-button>
    </div>

    <!-- Table view -->
    <div class="card card-body p-0 mt-3" v-if="results">
      <b-table :fields="fields"
               :items="results.metrics" empty-text="loading..."
               striped
               hover
               responsive
               ref="dataTable"
      >
      </b-table>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { download } from "@/utils";

export default {
  name: 'QueriesEntryUrls',
  metaInfo: {
    title: 'Queries - Brooks - Place Order Errors',
  },
  data () {
    return {
      clients: [],
      dateFrom: DateTime.now().minus({ days: 30 }).toFormat('yyyy-LL-dd'),
      dateTo: DateTime.now().toFormat('yyyy-LL-dd'),
      loading: false,
      formsSelected: null,
      results: null,
      fields: [
        { key: 'stage', label: 'Stage', sortable: true, thStyle: 'width: 8rem;' },
        { key: 'locale', label: 'Locale', sortable: true, thStyle: 'width: 8rem;' },
        { key: 'PlaceOrderError', label: 'Error', sortable: true, tdClass: 'tdStyle' },
        { key: 'sessions', label: 'Sessions (unique)', sortable: true, thStyle: 'width: 8rem;' },
      ],
    }
  },
  methods: {
    async reload () {
      this.loading = true

      this.clients = this.$root?.me?.grants?.combined?.filter(c => c.name.indexOf('brooksrunning.') !== -1).map(c => c.client_hash)

      this.loading = false
    },
    async getErrors () {
      if (!this.clients?.length) return
      this.results = (await this.$api.post('/metrics/brooks/placeordererrors', {
        from: this.dateFrom,
        to: this.dateTo,
        clients: this.clients,
      },this.$root.client.client_hash)).data
    },
    async exportResults () {
      if (!this.clients?.length) return

      await download(await this.$api.post('/metrics/brooks/placeordererrors', {
        from: this.dateFrom,
        to: this.dateTo,
        clients: this.clients,
        format: 'xlsx'
      },this.$root.client.client_hash, { responseType: 'blob' }))
    },
  },
  watch: {
    '$root.client': {
      handler () {
        if (this.$root.client) {
          this.reload()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
:deep(.tdStyle) {
  overflow-wrap: break-word;
  word-break: break-all;       /* Breaks at any character */
  white-space: normal;         /* Allows wrapping */
  max-width: 100%;             /* Constrains to parent width */
}
INPUT[title]::before {
  content: attr(title);
  position: absolute;
  font-weight: bold;
  margin-top: -1.75rem;
  font-size: 85%;
}
</style>
